import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { BDSProvider, CssBaseline } from '@barracuda-internal/bds-core';
import GuardianApp from 'guardian/App';
import { ThemeModeProvider, useThemeMode } from 'common/ThemeMode';

const BDSThemedShell = ({ children }) => {
  const { mode } = useThemeMode();
  return (
    <BDSProvider
      useBdsTheme={true}
      selectedBdsTheme={mode === 'dark' ? 'cudaDark' : 'cudaLight'}
    >
      <CssBaseline />
      {children}
    </BDSProvider>
  );
};

function App() {
  return (
    <ThemeModeProvider>
      <BDSThemedShell>
        <Switch>
          <Route path="/" component={GuardianApp} />
        </Switch>
      </BDSThemedShell>
    </ThemeModeProvider>
  );
}

export default App;
